import React from "react";

import {
    NhsOrganisationDto,
    NhsOrganisationsSearchResponse,
} from "@accurx/api/account";
import { Ds, Feedback } from "@accurx/design";
import { SelectCard } from "@accurx/navigation";

import { ResultsPagination } from "../../../shared/OrganisationSearch/ResultsPagination";

export const OrganisationList = ({
    title,
    data,
    type,
    onSelectOrganisation,
    showPreviousResults,
    showNextResults,
}: {
    title: string;
    data: NhsOrganisationsSearchResponse;
    type: "suggestions" | "search";
    onSelectOrganisation: (org: NhsOrganisationDto) => void;
    showPreviousResults: () => void;
    showNextResults: () => void;
}) => {
    return (
        <>
            <Ds.Text weight="bold">{title}</Ds.Text>
            {data.totalCount >= 100 && (
                <Feedback colour="information">
                    This search returned more than 100 results. Try adding more
                    details to narrow down the search.
                </Feedback>
            )}
            <Ds.Flex
                flexDirection="column"
                alignItems="stretch"
                data-testid={`organisation-list-${type}`}
                role="list"
            >
                {data.nhsOrganisations.map((org) => (
                    <Ds.Flex.Item role="listitem" key={org.id}>
                        <SelectCard
                            onClick={() => onSelectOrganisation(org)}
                            aria-label={`
                                Select to link ${org.name} as an organisation to your workspace.
                                Address: ${org.address.line1}.
                                Postcode: ${org.address.postCode}.
                                ODS Code: ${org.odsCode}.
                            `}
                        >
                            <Ds.Flex gap="1">
                                <Ds.Icon name="Carehome" size="small" />
                                <Ds.Flex flexDirection="column">
                                    <Ds.Text weight="bold">{org.name}</Ds.Text>
                                    <Ds.Text>
                                        {org.address.line1},{" "}
                                        {org.address.postCode} &#x2022;{" "}
                                        {org.odsCode}
                                    </Ds.Text>
                                </Ds.Flex>
                            </Ds.Flex>
                        </SelectCard>
                    </Ds.Flex.Item>
                ))}
            </Ds.Flex>
            {data.totalPages > 1 && (
                <ResultsPagination
                    totalPages={data.totalPages}
                    currentPage={data.currentPage}
                    onPrevious={showPreviousResults}
                    onNext={showNextResults}
                />
            )}
        </>
    );
};
